import { ResourceType } from '@repo/api-gw-sdk';

export const ZERO_ETL_SUPPORTED_RESOURCE_TYPES: ResourceType[] = [
  // AWS
  ResourceType.AwsEc2,
  ResourceType.AwsRds,
  ResourceType.AwsDynamoDb,
  // GCP
  ResourceType.GcpComputeEngineInstance,
  ResourceType.GcpCloudSqlInstance,
  ResourceType.GcpBigQuery,
  // Azure
  ResourceType.AzureVirtualMachine,
  ResourceType.AzureSqlDatabase,
  ResourceType.AzureSqlManagedInstance,
];
